// extracted by mini-css-extract-plugin
export default {"actionsTitlePanel":"FolderDetail_actionsTitlePanel__QowOc","contactsTabs":"FolderDetail_contactsTabs__-9Zwp","tableHeight":"FolderDetail_tableHeight__7jF0T"};